<template>
    <div class="index">
        <div class="cards">
            <div class="card">
                <div class="card-title">资料信息</div>
                <div class="card-avatar">
                    <div class="card-avatar__image">
                        <img :src="userInfo.avatar" mode="scaleToFill" v-if="userInfo.avatar" />
                        <img src="../../assets/img/img_defalult_avatar.png" v-else mode="scaleToFill" />
                    </div>
                    <!-- <div class="card-avatar__tips">
                        只支持JPG、JPEG或PNG格式的图片文件
                    </div> -->
                </div>
                <!-- <div class="card-btns">
                    <div class="card-btns__cancel">
                        <button @click="deleteAvatar()">删除头像</button>
                    </div>
                    <div class="card-btns__confirm">
                        <button @click="updateAvatar()">更改头像</button>
                    </div>
                </div> -->
                <div class="card-form">
                    <div class="card-form__line">
                        <span>名称</span>
                        <normal-input key="nickname" ref="nickname" keyname="nickname" v-model="userInfo.nickname"
                            clearable :isShowIcon='false' placeholder="请输入名称" label="" type="" :rules="nameRules"
                            :maxlength="20" :isAutoFocus="true" update:modelValue="inputUpdate"
                            @dropDownValueChange="fruitValueChange"></normal-input>

                    </div>
                    <!-- <div class="card-form__line">
                        <span>性别</span>
                        <div class="card-form__content" @click="showGender()">
                            <span>{{ genderList[userInfo.gender].text }}</span>
                            <van-popup v-model="showGenderValue" position="bottom">
                                <van-picker show-toolbar :columns="genderList" @change="onChange" />
                            </van-popup>
                            <img src="../../assets/icon/right.png" alt="">
                        </div>
                    </div> -->
                    <div class="card-form__line">
                        <span>手机号</span>
                        <normal-input key="mobile" keyname="mobile" v-model="userInfo.mobile" clearable
                            :isShowIcon='false' :isDisabled="false" placeholder="请输入手机号" label="" type=""
                            :maxlength="20" :isAutoFocus="true" isDisabled update:modelValue="inputUpdate"
                            @dropDownValueChange="fruitValueChange"></normal-input>

                    </div>

                </div>
            </div>
        </div>
        <div class="index-btn">
            <button @click="userEdit" :style="disabledValue ? '' : 'background: #f8dda1;'"
                :disabled='!disabledValue'>提交信息</button>
        </div>
    </div>
</template>


<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import NormalInput from '@/components/normalInput.vue'
import { Popup, Picker, Toast } from 'vant'
import qs from 'qs'
Vue.use(Popup);
Vue.use(Picker);
export default {
    name: 'UserDetails',
    data() {
        return {
            userInfo: {
                name: '',
                mobile: '',
                gender: '',
                avatar: '',
                nickname:''
            },
            nicknameVerify: false,
            showGenderValue: false,
            genderList: [{
                text: '女',
                value: 0,
            }, {
                text: '男',
                value: 1,
            }, {
                text: '未知',
                value: 2,
            }],
            nameRules: [
                { type: 'isSpecialChar', message: '不能包含特殊字符和表情，且长度不能超过32位' },
                { type: 'isNameLength', message: '长度必须保证在1~32位', min: 1, max: 32 },
            ],
            mobileRules: [
                { type: 'isPhoneNumber', message: '手机号格式不对' },
            ]
        }
    },
    computed: {
        disabledValue() {
            return (this.nicknameVerify)
        }
    },
    components: {
        NormalInput
    },
    created() {
        this.userInfo = this.$store.getters.userInfo
    },
    methods: {
        fruitValueChange(e, keyname) {
            this[keyname + 'Verify'] = e
        },
        submit(e) {
            console.log(e, this.userInfo)

        },
        onChange(value, index) {
            console.log('当前值：' + value + '当前索引：' + index);
        },
        showGender() {
            this.showGenderValue = !this.showGenderValue
        },

        userEdit() {
            let that = this;
            let url = `user/${this.userInfo.id}/edit/`
            let params = {
                name: this.userInfo.nickname
            };
            this.axios.post(url, qs.stringify(params), {
                headers: {
                    'x-user-token': that.$store.getters.token,
                    // 'Content-Type': 'application/x-www-form-urlencoded' // 添加Content-Type头
                }
            }).then(function () {
                Toast('修改成功')
                that.$router.go(-1)
            }).catch(function () {
                Toast('修改失败')
            })
        }

    }
}
</script>
<style lang="scss" scoped>
.index {
    background: #F6F8FA;
    height: 233px;
    background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);

    .cards {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-left: 15px;
        margin-right: 15px;

        .card {
            position: relative;
            display: flex;
            flex-direction: column;
            gap: 24px;
            padding: 16px;
            margin-top: 10px;
            background: #FFFFFF;
            border-radius: 16px;

            .card-title {
                font-size: 16px;
                font-weight: bold;
                color: #111827;
            }

            &-avatar {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 8px;


                &__image {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 80px;
                    height: 80px;
                    border-radius: 100%;
                    overflow: hidden;
                }

                &__tips {
                    font-size: 12px;
                    color: #A0AEC0;
                }
            }

            &-btns {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;

                &__cancel,
                &__confirm {
                    flex: 1;

                    button {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding: 14px 24px;
                        font-size: 16px;
                        border-radius: 12px;
                        box-sizing: border-box;
                        border-style: none;
                    }
                }

                &__cancel {
                    button {
                        color: #FAC859;
                        background: #ffffff;
                        border: 1px solid #FAC859;
                    }
                }

                &__confirm {
                    button {
                        color: #ffffff;
                        background: #FAC859;
                    }
                }
            }

            &-form {
                display: flex;
                flex-direction: column;
                gap: 18px;

                &__line {
                    display: flex;
                    flex-direction: column;
                    gap: 12px;

                    text {
                        font-size: 14px;
                        color: #718096;
                    }

                    input {
                        padding: 14px 16px;
                        font-size: 14px;
                        color: #111827;
                        background: #F6F8FA;
                        border-radius: 12px;
                        z-index: 0;
                    }
                }

                &__content {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 16px;
                    font-size: 14px;
                    background: #f6f8fa;
                    border-radius: 12px;

                    img {
                        width: 16px;
                        height: 16px;
                        transform: rotate(90deg);
                    }
                }
            }

            /deep/ .login-input {
                font-size: 14px;
                color: #111827;
                background: #F6F8FA !important;
                border-radius: 12px;
                z-index: 0;
                border: none !important;

                input {
                    background-color: transparent !important;
                }
            }
        }
    }

    &-btn {
        position: fixed;
        bottom: 35px;
        left: 0;
        right: 0;
        padding-bottom: 20px;
        margin-left: 15px;
        margin-right: 15px;

        button {
            width: 100%;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-top: 15px;
            padding-bottom: 15px;
            background: #FAC859;
            box-shadow: 0px 4px 8px 0px rgba(250, 200, 89, 0.11);
            border-radius: 12px;
            font-weight: 500;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            border-style: none
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userDetails.vue